import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { withCookies } from 'react-cookie';
// import useQueryString from './../../utilities/use-query-string';

import Fetching from './../utilities/fetching';

import Header from '../core/header.js'
import Footer from '../core/footer.js'
import Loader from './../common/loader';
import PaginatorLinks from '../common/paginator/paginator-links.js';

import MainTitle from '../common/titles/main-title.js';

import UsrDetailLightbox from './../common/usr-details-lightbox';
import LightboxCreateUser from './../common/lightbox-create-user.js';
import LightboxUpdateUser from './../common/lightbox-update-user.js';


class UserList extends Component {

    constructor(props){
        super(props);
        this.state = {
            openUpdate : false,
            openCreate : false,
            loading: false,
            users: [],
            pages: 0,
            total: 0,
            current: 0,
            msg: false,
            displayUsr: false,
            editUsr: false,
            auth: false
        }

        this.loadUsers = this.loadUsers.bind(this);
        this.closeDetails = this.closeDetails.bind(this);
        this.toggleUpdateLightbox = this.toggleUpdateLightbox.bind(this);
        this.toggleCreateLightbox = this.toggleCreateLightbox.bind(this);
    }

    toggleUpdateLightbox(e, msgUpdate, uid,reloadData){
        if (e !== null) {
            e.preventDefault();
        }
        if (typeof msgUpdate == "undefined") msgUpdate = false;

        if(reloadData){
            this.loadUsers(true, this.state.auth);
        }

        this.setState(prevState => ({
            openUpdate: !prevState.openUpdate,
            msg: msgUpdate,
            editUsr: uid
        }));
    }

    toggleCreateLightbox(e, msgUpdate,reloadData){
        if (e !== null){
            e.preventDefault();
        }

        if(reloadData){
            this.loadUsers(true, this.state.auth);
        }
        
        if (typeof msgUpdate == "undefined") msgUpdate = false;
        this.setState(prevState => ({
            openCreate: !prevState.openCreate,
            msg: msgUpdate
        }));
    }

    componentDidMount () {
        // Get the auth cookie data 
        let auth = this.props.cookies.get('ldt-auth');
        this.setState({ auth: auth });
        this.loadUsers(true, auth);
    }

    // Load up the users into the component 
    loadUsers ( displayLoader, usrAuth ) {

        // If it is this type of query display the loader 
        if (typeof displayLoader != 'undefined') {
            this.setState({ loading: true });
        }

        // Work out whether a page is mentioned 
        var qsParams = this.props.location.search.replace("?", "");
        qsParams = qsParams.split("&");
        var page = false;
        for (var j in qsParams) {
            if (qsParams[j].indexOf("page=") > -1) {
                page = qsParams[j].replace("page=", "");
            }
        }

        if ( !page ) page = 1;
        page = Number(page);

        // Get the auth details of the user
        if ( typeof usrAuth == "undefined" ) {
            let { auth } = this.state;
            usrAuth = auth;
        }

        // Get the users
        var thus = this;
        fetch(process.env.REACT_APP_API_BASE + '/users?page=' + page, {
            method: 'get',
            headers: { 
                "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
                "apiToken": usrAuth.apiToken,
                "apiKey": usrAuth.apiKey
            },
        })
        .then(Fetching.statusCheck)
        .then(Fetching.jsonExtract)
        .then(function (data) {
            thus.setState({ users: data.rslts, pages: data.pages, total: data.total, current: data.current, loading: false });
        })
        .catch(function (error) {
            console.log('Request failed', error);
        });
    }

    viewDetails ( e, uRef ) {
        e.preventDefault();
        this.setState({ displayUsr: uRef });
    }

    closeDetails ( e ) {
        e.preventDefault();
        this.setState({ displayUsr: false });
    }

    toggleUserStatus ( e, uRef ) {

        e.preventDefault();
        this.setState({ msg: false });

        let { auth } = this.state;

        // Get the users
        var thus = this;
        fetch(process.env.REACT_APP_API_BASE + '/users/' + uRef + "/toggle", {
            method: 'get',
            headers: {
                "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
                "apiToken": auth.apiToken,
                "apiKey": auth.apiKey
            },
        })
            .then(Fetching.statusCheck)
            .then(Fetching.jsonExtract)
            .then(function (data) {
                if (data) {
                    thus.loadUsers();
                    thus.setState({ msg: { content: "The user status has been successfully updated.", className: "message success" } });
                } else {
                    thus.setState({ msg: { content: "Sorry but there was an issue updating the user status. Please try again.", className: "message" }});
                }
            })
            .catch(function (error) {
                console.log('Request failed', error);
            });

    }

    deleteUsr (e, uRef) {

        e.preventDefault();
        this.setState({ msg: false });

        let { auth } = this.state;

        // Get the users
        var thus = this;
        fetch(process.env.REACT_APP_API_BASE + '/users/' + uRef, {
            method: 'delete',
            headers: {
                "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
                "apiToken": auth.apiToken,
                "apiKey": auth.apiKey
            },
        })
            .then(Fetching.statusCheck)
            .then(Fetching.jsonExtract)
            .then(function (data) {
                if (data) {
                    thus.loadUsers();
                    thus.setState({ msg: { content: "The user has been successfully deleted.", className: "message success" } });
                } else {
                    thus.setState({ msg: { content: "Sorry but there was an issue deleting this user. Please try again.", className: "message" } });
                }
            })
            .catch(function (error) {
                console.log('Request failed', error);
            });

    }


  render() {

    let { loading, users, total, pages, current, msg, displayUsr, openCreate, openUpdate, auth, editUsr } = this.state;


    return (
        <Fragment>

            { openCreate ? (
                <LightboxCreateUser
                    closeFunc={this.toggleCreateLightbox}
                    auth={ auth }
                />
            ) : ""}

            {openUpdate ? (
                <LightboxUpdateUser
                    uid={editUsr}
                    auth={auth}
                    closeFunc={this.toggleUpdateLightbox}
                />
            ) : ""}

            { displayUsr ? (
                <UsrDetailLightbox
                    uid={ displayUsr }
                    auth={auth}
                    closeFunc={ this.closeDetails }
                />
            ) : "" }

            <Header/>
            
            <section className="content">
                <div className="width-9 centred">
                
                    <button className="right"  onClick={(e) => this.toggleCreateLightbox(e)}>New User</button>
                    <Link className="right btn email-btn" to='/admin/emails'>Emails</Link>
                    <MainTitle text='Manage Users'/>

                    { msg ? (
                        <div className={ msg.className }>
                            { msg.content }
                        </div>
                    ) : ""}
                </div>
                
                <div className="width-9 centred">
                    <table className='manage-users-table'>
                        <thead>
                            <tr>
                                <th>First name</th>
                                <th>Last name</th>
                                <th className='rx-1100-hidden'>Email Address</th>
                                <th className='rx-800-hidden'>Status</th>
                                <th className='rx-800-hidden'>Role</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            { loading ? (
                                <tr className="holding">
                                    <td colSpan="6">
                                        <Loader />
                                    </td>
                                </tr>
                            ) : (
                                <Fragment>
                                    { users.map( usr => 
                                        <tr className={ usr.status === "active" ? "normal" : "cancelled" } key={ 'usr-' + usr.public_id }>
                                            <td><Link to="/" onClick={(e) => this.viewDetails(e, usr.public_id)}>{ usr.first_name }</Link></td>
                                            <td><Link to="/" onClick={(e) => this.viewDetails(e, usr.public_id)}>{usr.last_name}</Link></td>
                                            <td className='rx-1100-hidden'>{ usr.email_address }</td>
                                            <td className='rx-800-hidden'>{ usr.status.charAt(0).toUpperCase() + usr.status.slice(1) }</td>
                                            <td className='rx-800-hidden'>{ usr.role.charAt(0).toUpperCase() + usr.role.slice(1) }</td>
                                            <td style={{ textAlign: 'right' }}>
                                                <Link to={"/admin/emails/user/"+usr.public_id}  className="btn">Emails</Link>
                                                <Link to="/" onClick={(e) => this.toggleUpdateLightbox(e, false, usr.public_id)} className="btn">Edit</Link>
                                                <Link to="/" className="btn user-lock-toggle" onClick={(e) => this.toggleUserStatus(e, usr.public_id)}>{usr.status === "active" ? "Lock" : "Unlock"}</Link>
                                                <Link to="/" className="btn btn-dark" onClick={ (e) => this.deleteUsr(e, usr.public_id) }>Delete</Link>
                                            </td>
                                        </tr>
                                    )}
                                </Fragment>
                            )}
                        </tbody>
                    </table>

                    { !loading && pages > 1 ? (
                        <PaginatorLinks 
                            actionFunc={ this.loadUsers }
                            total={ total }
                            current={ current }
                            pages={ pages }
                            baseUrl={ "/manage-users" }
                            delay={ 10 }
                        />
                     ) :"" }
                </div>

            </section>
            
            <Footer/>
        </Fragment>
    );
  }
}



export default withCookies(UserList);
